import React, { useState } from "react";
import BrandGuideList from "./BrandGuideList";
import BrandGuideModal from "./BrandGuideModal";
import { BrandGuideItem } from "./api";
import { useT } from "../../i18n";

const Item: React.FC = () => {
  const t = useT();
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState<BrandGuideItem | null>(null);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleCreateNew = () => {
    setEditingItem(null);
    setIsModalOpen(true);
  };

  const handleEditItem = (item: BrandGuideItem) => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingItem(null);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Header - matching Product Sheet design */}
      <header className="flex items-center justify-between h-20 px-8 bg-white border-b border-gray-200">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            {t("brandGuide.title")}
          </h2>
          <p className="text-sm text-gray-500">
            {t("brandGuide.subtitle")}
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <button
            onClick={handleCreateNew}
            data-testid="add-brand-guide-btn"
            className="px-5 py-2.5 flex items-center bg-[#111827] text-white rounded-lg hover:bg-gray-800 transition-colors text-sm font-medium shadow-sm"
          >
            <i className="fa-solid fa-plus mr-2"></i>
            {t("brandGuide.addItem")}
          </button>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 p-8">
        {/* Brand Guide List with integrated search and controls */}
        <BrandGuideList
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
          onEditItem={handleEditItem}
        />
      </main>

      {/* Brand Guide Modal */}
      <BrandGuideModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        editingItem={editingItem}
      />
    </div>
  );
};

export default Item;
